<script>
  import { pop, push, querystring } from "svelte-spa-router";
  import { fade } from "svelte/transition";
  import { user, showPopup } from "../stores";
  import { onMount, tick } from "svelte";
  import * as InitService from "../bl/init-service";

  let phoneNumber = ""; //for 55-123-1234 code will be 334433
  let verificationCode = "";
  let status = "";
  let slides;
  let phoneInput;
  let codeInput;
  let isCountryCodeInNumber = false;
  let defaultCountryCode = "972";

  user.subscribe((u) => {
    if (u && $querystring.search("showAuth=true") != -1) {
      pop();
    }
  });

  async function sendSms() {
    if (phoneNumber == "") return;
    const noZerosNumber = phoneNumber.replace(/^0+/, "");
    const completeNumber = isCountryCodeInNumber
      ? `+${phoneNumber}`
      : `+${defaultCountryCode}${noZerosNumber}`;
    phoneInput.disabled = true;
    window.auth
      .sendSms(completeNumber)
      .then((cred) => {
        gotoEnterCode();
      })
      .catch((err) => {
        // status = err.toString();
        status = "Error";
        phoneInput.disabled = false;
        // can't send log because no one is logged in yet
        showPopup(
          `Sending sms to number: ${completeNumber} failed: ${err.toString()}`,
          () => {}
        );
      });
  }

  async function verifyCode() {
    // codeInput.disabled = true;ֿ

    try {
      const verified = await window.auth.verifyCode(
        String(verificationCode),
        InitService.authStateChanged
      );
      if (!verified) {
        status = "שגיאה";
        codeInput.disabled = false;
      }
    } catch (e) {
      status = "שגיאה";
      codeInput.disabled = false;
    }
  }

  function phoneInputKeyDown(e) {
    if (e.keyCode == 8 && !e.target.value) {
      // backspace
      isCountryCodeInNumber = true;
    }
  }

  function filterInput(e) {
    //only numbers allowed
    if (e.keyCode != 13 && (e.keyCode < 48 || e.keyCode > 57)) {
      e.preventDefault();
    }

    if (e.keyCode == 13) {
      if (e.target == phoneInput) {
        if (e.target.value.length > 8) {
          sendSms();
        }
      } else if (e.target == codeInput) {
        if (e.target.value.length == 6) {
          verifyCode();
        }
      }
    }
  }

  function gotoEnterCode() {
    status = "";
    slides.scrollTo(-1000, 0);
    codeInput.disabled = false;
  }

  function gotoEnterPhone() {
    status = "";
    slides.scrollTo(0, 0);
    phoneInput.disabled = false;
  }

  onMount(async () => {
    await tick();
    if (!window.cordova) {
      var uiConfig = {
        // signInSuccessUrl: "/",
        callbacks: {
          signInSuccessWithAuthResult: () => {},
        },
        signInOptions: [
          // Leave the lines as is for the providers you want to offer your users.
          {
            provider: firebase.auth.PhoneAuthProvider.PROVIDER_ID,
            recaptchaParameters: {
              type: "image", // 'audio'
              size: "invisible", // 'invisible' or 'compact'
              badge: "bottomleft", //' bottomright' or 'inline' applies to invisible.
            },
            defaultCountry: "IL", // Set default country to the United Kingdom (+44).
          },
        ],
        // tosUrl and privacyPolicyUrl accept either url string or a callback
        // function.
        // Terms of service url/callback.
        tosUrl: "https://pickapp.netlify.app/#/eula",
        // Privacy policy url/callback.
        privacyPolicyUrl: function () {
          window.location.assign("https://pickapp.netlify.app/#/eula");
        },
      };

      // Initialize the FirebaseUI Widget using Firebase.
      if (!window.firebaseuiinstance)
        window.firebaseuiinstance = new firebaseui.auth.AuthUI(firebase.auth());

      // The start method will wait until the DOM is loaded.
      window.firebaseuiinstance.start("#firebaseui-auth-container", uiConfig);
      // let title = document.getElementsByClassName("firebaseui-title")[0];
      // title.classList.add("firebaseAuthTitle");

      // let btn = document.getElementsByClassName("firebaseui-button")[0];
      // btn.classList.add("firebaseAuthBtn");
    }
    return;
    // phoneInput.focus();
  });

</script>

<div
  class="bg"
  on:mousedown={(e) => {
    pop();
  }}
  transition:fade={{ duration: 100 }}
>
  <main
    class:cordovaHeight={window.cordova}
    on:mousedown={(e) => {
      e.stopPropagation();
    }}
  >
    <div class="blue-circle" />
    <div class="logo"><img src="images/logo_white.svg" alt="logo" /></div>
    <!-- <div class="status">נשלח</div> -->
    <div class="slides" bind:this={slides}>
      {#if !window.cordova}
        <div class="slide sendSms" id="firebaseui-auth-container" />
      {:else}
        <div class="slide sendSms">
          <h2>מס.טלפון</h2>
          <div class="number">
            <input
              bind:this={phoneInput}
              maxlength="12"
              type="tel"
              bind:value={phoneNumber}
              on:keypress={filterInput}
              on:keydown={phoneInputKeyDown}
            />
            <span class="countryCodePlus">+</span>
            {#if !isCountryCodeInNumber}
              <span class="countryCode">{defaultCountryCode}</span>
            {/if}
          </div>
          <button id="sign-in-button" on:click={sendSms}>שליחה</button>
        </div>
        <div class="slide sendSms">
          <span>
            שלחנו קוד למספר
            {phoneNumber}
            <br />
            לא קיבלת?
            <span class="sendAgain" on:click={sendSms}>שלח שוב</span>
          </span>
          <h2>קוד:</h2>
          <input
            bind:this={codeInput}
            maxlength="6"
            inputmode="numeric"
            type="text"
            id="code"
            on:keypress={filterInput}
            bind:value={verificationCode}
          />
          <div class="arrow right" on:click={gotoEnterPhone} />
          <button id="vrifyCodeBtn" on:click={verifyCode}>שלח</button>
        </div>
      {/if}
    </div>
    <div
      class="status"
      style={'color:' + (status.includes('שגיאה') ? '#ff5656' : '#222')}
    >
      {status}
    </div>
  </main>
</div>

<style>
  :global(#firebaseui-auth-container
      > div
      > form
      > div.firebaseui-card-header
      > h1) {
    direction: rtl;
    text-align: right;
    font-family: "Rubik";
    color: var(--grey1);
  }

  :global(.firebaseui-card-header) {
    border-bottom: none !important;
    padding: 6px 16px 8px 24px;
    margin-bottom: 0 !important;
  }

  :global(.firebaseui-label) {
    text-align: right;
  }
  :global(#firebaseui-auth-container
      > div
      > form
      > div.firebaseui-card-actions
      > div
      > button) {
    background: #24d4f0 !important;
    box-shadow: none !important;
  }

  :global(#firebaseui-auth-container
      > div
      > form
      > div.firebaseui-card-content
      > div
      > div.firebaseui-phone-number
      > div
      > input) {
    text-align: left;
  }
  :global(#firebaseui-auth-container
      > div
      > form
      > div.firebaseui-card-content
      > p, #firebaseui-auth-container
      > div
      > form
      > div.firebaseui-card-content
      > div.firebaseui-textfield.mdl-textfield.mdl-js-textfield.mdl-textfield--floating-label.is-upgraded
      > label, #firebaseui-auth-container
      > div
      > form
      > div.firebaseui-card-content
      > div.firebaseui-textfield.mdl-textfield.mdl-js-textfield.mdl-textfield--floating-label.is-upgraded
      > input) {
    text-align: right;
    font-family: "Rubik";
  }

  :global(.firebaseui-id-page-phone-sign-in-start) {
    position: static;
  }

  :global(.mdl-textfield) {
    margin-top: 10px;
  }

  :global(.firebase-text) {
    direction: rtl;
  }
  :global(.firebaseui-text) {
    direction: rtl;
    margin-top: 0;
    margin-bottom: 0;
    font-size: 14px !important;
  }

  :global(#firebaseui-auth-container > div) {
    box-shadow: none !important;
  }

  :global(.firebaseui-tos) {
    margin-bottom: 0;
  }

  :global(.mdl-dialog) {
    top: 0 !important;
  }

  :global(.firebaseui-tos.firebaseui-phone-tos) {
    white-space: pre-line;
    direction: rtl;
    text-align: right;
  }

  :global(.firebaseui-title) {
    margin-bottom: 0 !important;
    padding-bottom: 0 !important;
  }

  :global(.firebaseui-card-footer) {
    padding-bottom: 14px;
  }
  :global(.firebaseui-resend-container) {
    /* margin: 35px 0; */
    text-align: center;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .cordovaHeight {
    height: 275px !important;
  }
  .bg {
    width: 100%;
    height: 100%;
    background: #000000c7;
    display: flex;
    justify-content: center;
    position: fixed;
    z-index: 999;
    max-height: calc(100vh - var(--nav-bar-height));
    height: calc(100vh - var(--nav-bar-height));
    width: 100%;
    overflow: auto;
    box-sizing: border-box;
  }
  main {
    padding-top: 190px;
    position: relative;
    background: white;
    border-radius: 5px;
    font-family: "Rubik";
    font-size: 15px;
    height: 310px;
    width: 100%;
    max-width: 310px;
    overflow: hidden;
    display: flex;
    justify-content: center;
    margin-top: 40px;
  }

  .blue-circle {
    position: absolute;
    background: var(--blue1);
    width: 1200px;
    height: 1200px;
    top: -1040px;
    border-radius: 1200px;
  }

  .logo {
    z-index: 999;
    position: absolute;
    top: 23px;
  }

  .logo > img {
    width: 110px;
  }

  .slides {
    direction: rtl;
    position: absolute;
    display: flex;
    width: 100%;
    overflow: hidden;
    white-space: nowrap;
    scroll-behavior: smooth;
    scroll-snap-type: x mandatory;
    box-sizing: border-box;
    user-select: none;
  }

  .slide {
    position: relative;
    width: 100%;
    min-width: 100%;
    height: 100%;
    display: inline-block;
    display: flex;
    flex-direction: column;
    align-items: center;
  }

  .slide > span {
    color: #999;
  }

  .sendSms {
    text-align: center;
  }

  .number {
    direction: ltr;
    position: relative;
    display: flex;
    align-items: center;
    justify-content: flex-start;
    font-size: 18px;
    margin-top: 10px;
  }

  .countryCode {
    position: absolute;
    margin-left: 24px;
    color: #8a8a8a;
    top: 14px;
  }

  .countryCodePlus {
    position: absolute;
    margin-left: 12px;
    color: #8a8a8a;
    top: 14px;
  }

  input {
    width: 210px;
    margin: 0;
    padding: 5px;
    padding-left: 62px;
    -webkit-appearance: none;
    border-radius: 7px;
    letter-spacing: 2px;
    margin-top: 8px;
  }

  button {
    cursor: pointer;
  }

  input:focus {
    border: 1.5px solid var(--blue1);
    outline: none;
  }

  input::-webkit-outer-spin-button,
  input::-webkit-inner-spin-button {
    /* display: none; <- Crashes Chrome on hover */
    -webkit-appearance: none;
    margin: 0; /* <-- Apparently some margin are still there even though it's hidden */
  }

  button {
    width: 120px;
    height: 60px;
    border-radius: 510px;
    padding: 0;
    margin: 0;
    background: var(--blue1);
    color: white;
    font-size: 22px;
    border: 3px solid white;
    box-shadow: 0 0 0px 3px var(--blue1);
    margin-top: 40px;
    margin-bottom: 20px;
  }

  h2 {
    margin: 0%;
    margin-top: 4px;
  }

  .status {
    position: absolute;
    bottom: 10px;
  }

  .arrow {
    margin: 15px;
    border-radius: 3px;
    border: solid var(--blue1);
    border-width: 0 6px 6px 0;
    display: inline-block;
    padding: 4px;
    position: absolute;
    right: 10px;
  }

  .right {
    transform: rotate(-45deg);
  }

  @media only screen and (max-width: 360px), (max-height: 570px) {
    main {
      margin-top: 0;
      max-width: unset;
      border-radius: 0;
      max-height: none;
      padding-bottom: 20px;
      padding-top: 240px;
      overflow-y: auto;
      min-height: calc(100vh - var(--nav-bar-height));
      box-sizing: border-box;
    }

    .slides {
      bottom: unset;
    }

    .logo {
      top: 36px;
    }

    .blue-circle {
      top: -1010px;
    }

    :global(.firebaseui-card-footer) {
      margin-top: 0px;
    }
  }

</style>
